<app-popup-page
  [config]="config"
  (closePopup)="closeModal()"
  (pageBack)="back()"
  (pageNext)="next()"
  [popupHeight]="'300px'"
  [popupWidth]="'400px'"
>
  <app-variant-locked-step (config)="updateConfig($event)"></app-variant-locked-step>
</app-popup-page>
